<template>
  <div
    v-show="showFooterBar"
    id="fixedbottom"
    class="fixed-button-custom btn-tab-group"
  >
    <CustomHR variant="success" class="mt-0" />
    <div class="col-12 mb-3">
      <div class="container-foot d-flex justify-content-end">
        <ActionButton
          :id="id"
          type="submit"
          variant="success"
          i="fas fa-save"
          @click="save"
        >
          Guardar
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import CustomHR from '@/components/common/page/CustomHR';
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'FixedBottomSaveButton',
  components: {
    CustomHR,
    ActionButton,
  },
  data() {
    return {
      showFooterBar: false,
    };
  },
  props: {
    id: {
      type: String,
      default: 'btnSave',
      meta: {
        description: 'Id del Boton de accion',
        example: 'btnSave',
      },
    },
    offset: {
      type: Number,
      default: () => 250,
    },
  },
  methods: {
    save() {
      this.$emit('click');
    },
    handleScroll() {
      let currentScrollPos = window.pageYOffset;
      this.showFooterBar = this.offset <= currentScrollPos;
      this.prevScrollpos = currentScrollPos;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
#fixedbottom {
  background-color: #fff;
}

.fixed-button-custom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 118px;
  z-index: 1030;
}
</style>
